const transformEmptyToNull = (value: any) => (value === '' ? null : value);

function formatToReal(value: number): string {
  if (isNaN(value)) return 'Valor inválido';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

export const stringUtils = {
  transformEmptyToNull,
  formatToReal,
};
